
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import layout from '@/layout/page-with-header'
import ListTable from './ListTable'
import EntryDialog from './EntryDialog'
const components = {
  layout,
  ListTable,
  EntryDialog,
}


/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = {
  ...mapGetters({
    isLoading: `Product/Transaction/loadingState`,
  }),
}

/**
 * Methods
 *
 */
const methods = mapActions({
  reload: `Product/Transaction/fetchList`,
})

methods.addNewRecord = function() {
  this.$refs.EntryDialog.show()
}

methods.viewProductTransaction = function() {
  this.$router.push(`/product/transactionitem`)
}

/**
 * Event OnMounted
 *
 */
const mounted = function() {
}

/**
 * Event OnCreated
 *
 */
const created = function() {
  this.$store.commit(`set_page_title`, `Produk dan Inventory`)
  this.$store.commit(`set_breadcrumb`, [ `Inventory`, `Data Transaksi` ])
}

export default {
  components,
  data,
  computed,
  methods,
  mounted,
  created,
}
</script>

<style scoped>
</style>

<template>
  <layout>
    <Row>
      <BlockTable :loading="isLoading">
        <template #header>
          Data Keluar Masuk Produk

          <ButtonR text="Tambah Record" color="primary" @click="addNewRecord" />
          <ButtonR text="Tampilan Produk" color="default" @click="viewProductTransaction" />
          <ButtonR icon="repeat" color="default" @click="reload" />
        </template>
        <template #content>
          <ListTable />
        </template>
      </BlockTable>
    </Row>

    <EntryDialog ref="EntryDialog"></EntryDialog>
  </layout>
</template>